import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'

import { StoreExt } from '@utils/reactExt'

import { doctors } from '@services/api'

export class doctorsStore extends StoreExt {
    @observable loading = false
    @observable list = []
    @observable filters = {}
    @observable paging = {
        page: 1,
        perPage: 0,
        total: 0,
        lastPage: 0,
        filters: {}
    }

    @action
    getDoctors = async page => {
        this.loading = true
        const { perPage, total, lastPage, data } = (await doctors.getList({ ...this.filters, page })).data
        const filters = { ...this.filters }
        runInAction(() => {
            this.list = data
            this.paging = { perPage, total, page, lastPage, filters }
            this.loading = false
        })
    }

    @action
    search = async params => {
        this.loading = true
        const { keywords, page } = params
        const { doctors: list, total } = (await doctors.search({ keywords, page })).data
        runInAction(() => {
            this.list = list
            this.paging['total'] = total
            this.paging['page'] = page
            this.loading = false
        })
    }

    @action
    changePage = page => {
        this.loading = true
        const filters = this.paging.filters
        runInAction(() => {
            this.paging.page = page
            this.filters = filters
            this.getDoctors(page)
        })
    }

    @action
    setFilter = (name, value) => {
        const newFilters = { ...this.filters }
        if (!value && value !== 0) {
            delete newFilters[name]
        } else {
            newFilters[name] = value
        }
        runInAction(() => {
            this.filters = { ...newFilters }
        })
    }

    @action
    resetFilters = () => {
        this.filters = {}
    }
}

export default remotedev(new doctorsStore())
